/* eslint-disable max-len */
// these functions are used to generate the content of the cards in the Your Savings Hub Page
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { msg } from 'api';

export function generateCouponCardContent(couponsToUse, couponsSumSavings) {
  const hasCoupons = couponsToUse && couponsToUse !== '0';
  const validCouponsSumSavings = typeof couponsSumSavings === 'number' && couponsSumSavings !== 0 ? `£${couponsSumSavings.toFixed(2)}` : '';
  return {
    couponsToUse: hasCoupons ? couponsToUse : '0',
    title: hasCoupons
      ? msg.yourSavingsHub.savingMoneySection.couponCard.title
      : msg.yourSavingsHub.savingMoneySection.couponCard.titleNoCoupons,
    description: hasCoupons
      ? msg.yourSavingsHub.savingMoneySection.couponCard.description
      : msg.yourSavingsHub.savingMoneySection.couponCard.descriptionNoCoupons,
    amountToSave: hasCoupons
      ? validCouponsSumSavings
      : msg.yourSavingsHub.savingMoneySection.couponCard.amountToSaveNoCoupons,
    buttonText: hasCoupons
      ? msg.yourSavingsHub.savingMoneySection.couponCard.buttonText
      : msg.yourSavingsHub.savingMoneySection.couponCard.buttonTextNoCoupons,
    buttonLinkCouponCard: hasCoupons
      ? msg.yourSavingsHub.buttonLinkCardCoupons
      : msg.yourSavingsHub.buttonLinkCardNoCoupons,
    className: 'card-content',
  };
}

export function generateSmartPassCardContent(smartPassType) {
  return {
    title: smartPassType
      ? `${msg.yourSavingsHub.savingMoneySection.smartPassCard.title
      } ${smartPassType}`
      : msg.yourSavingsHub.savingMoneySection.smartPassCard.titleNoSubscription,
    description: smartPassType
      ? msg.yourSavingsHub.savingMoneySection.smartPassCard.description
      : msg.yourSavingsHub.savingMoneySection.smartPassCard.descriptionNoSubscription,
    smartPassSumSavings: msg.yourSavingsHub.savingMoneySection.smartPassCard.smartPassSumSavings,
    buttonText: smartPassType
      ? msg.yourSavingsHub.savingMoneySection.smartPassCard.buttonText
      : msg.yourSavingsHub.savingMoneySection.smartPassCard.buttonTextNoSubscription,
    className: smartPassType ? 'card-content' : 'card-content_no-subscription',
  };
}

export function generatePricePromiseContent(pricePromiseSum, pricePromiseVoucher) {
  const formattedPricePromiseSum = (typeof pricePromiseSum === 'number' && pricePromiseSum !== 0) ? `£${pricePromiseSum.toFixed(2)}` : '';
  return {
    title: formattedPricePromiseSum ? msg.yourSavingsHub.savingMoneySection.pricePromise.title : '',
    description: formattedPricePromiseSum
      ? msg.yourSavingsHub.savingMoneySection.pricePromise.description
      : msg.yourSavingsHub.savingMoneySection.pricePromise.descriptionNoVoucher,
    pricePromiseSum: formattedPricePromiseSum || '',
    description2: formattedPricePromiseSum
      ? msg.yourSavingsHub.savingMoneySection.pricePromise.description2
      : msg.yourSavingsHub.savingMoneySection.pricePromise.description2NoVoucher,
    buttonText: formattedPricePromiseSum
      ? msg.yourSavingsHub.savingMoneySection.pricePromise.buttonText
      : msg.yourSavingsHub.savingMoneySection.pricePromise.buttonTextNoVoucher,
    pricePromiseVoucher: pricePromiseVoucher || '',
    className: formattedPricePromiseSum ? 'card-content' : 'card-content_no-voucher',
  };
}
export const cardsDataSavingTime = () => {
  const images = require.context('themes/ocado/assets/images/icons/ysh', false, /\.(svg)$/);

  const yshAppIcon = images('./grape_app.svg');
  const yshAppImgApple = images('./app_store_badge.svg');
  const yshAppImgAndroid = images('./google_play_store_badge.svg');
  const yshAppImgReserved = images('./grape_reserved.svg');
  const yshAppImgFavourites = images('./grape_fave.svg');
  const yshAppImgRegulars = images('./grape_regulars.svg');
  const yshAppImgInstantShop = images('./grape_instant_shop.svg');
  const yshAppImgShoppingLists = images('./grape_shopping_list.svg');
  const rightArrowIcon = images('./grape_right_arrow.svg');

  const icons = {
    reserved: yshAppImgReserved,
    favourites: yshAppImgFavourites,
    regulars: yshAppImgRegulars,
    instantShop: yshAppImgInstantShop,
    shoppingLists: yshAppImgShoppingLists,
  };

  const { yourSavingsHub: { cardsSavingTimeSection: sections } } = msg;
  const { savingTimeList, id: yshAppId, header: yshAppHeader, linkIOSApp, linkAndroidApp, altIOSApp, altAndroidApp } = sections.yshApp;

  const cards = Object.keys(sections).map(key => {
    if (key === 'yshApp') return null;
    const { id: sectionId, header: sectionHeader, content, buttonText, buttonLink } = sections[key];
    return {
      id: sectionId,
      icon: icons[key],
      header: sectionHeader,
      content: <p>{content}</p>,
      buttonText,
      buttonLink,
      rightArrowIcon,
    };
  }).filter(Boolean);

  cards.unshift({
    id: yshAppId,
    icon: yshAppIcon,
    header: yshAppHeader,
    content: (
      <>
        <ul className="saving-time-list">
          {savingTimeList.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <div className="card__content-footer download__app">
          <a href={linkIOSApp}>
            <img src={yshAppImgApple} alt={altIOSApp} />
          </a>
          <a href={linkAndroidApp}>
            <img src={yshAppImgAndroid} alt={altAndroidApp} />
          </a>
        </div>
      </>
    ),
    buttonText: '',
    buttonLink: '',
  });

  return cards;
};

export const getFaqAccordionContent = () => {
  const processContent = (content) => {
    if (typeof content === 'string') {
      return content;
    } else if (Array.isArray(content)) {
      return content.map(item => (
        <p key={item.text}>
          {item.text}
          {item.link && <a href={item.link.href}><strong> {item.link.text}</strong></a>}
        </p>
      ));
    } else if (typeof content === 'object') {
      return (
        <>
          {content.title && <h4>{content.title}</h4>}
          {Array.isArray(content.content)
            ? content.content.map(item => (
            <p key={item.text}>
              {item.text}
              {item.link && <a href={item.link.href}><strong> {item.link.text}</strong></a>}
            </p>
            )) : (
            <p>
              {content.text}
              {content.link && <a href={content.link.href}><strong> {content.link.text}</strong></a>}
            </p>
            )}
        </>
      );
    }
    return null;
  };

  const faqs = msg.yourSavingsHub.FaqAccordionSection.faqs.map(faq => ({
    id: uuidv4(),
    title: faq.title,
    content: processContent(faq.content),
  }));

  const additionalFaqs = msg.yourSavingsHub.FaqAccordionSection.additionalFaqs.map(faq => ({
    id: uuidv4(),
    title: faq.title,
    content: processContent(faq.content),
  }));

  return {
    faqs,
    additionalFaqs,
  };
};

export const getFaqAccordionSectionInfo = () => {
  const {
    sectionTitle,
    footerMoreQuestions,
    footerButtonTextMoreFaqs,
    footerHelpCentreLink,
    footerHelpCentreLinkText,
  } = msg.yourSavingsHub.FaqAccordionSectionGeneralInfo;

  return {
    sectionTitle,
    footerMoreQuestions,
    footerButtonTextMoreFaqs,
    footerHelpCentreLink,
    footerHelpCentreLinkText,
  };
};
